import React, { useEffect, useState } from "react"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';

const UnpaidOrder = (props) => {

    const handleSubmit = () => {
        props.submit();
    }

    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={'Mark order as unpaid'}
            titleIcon={'error'}
            positiveTitle={'Mark as unpaid'}
            positivePress={() => handleSubmit()}
            positiveButtonStyle={{backgroundColor: '#44d62c', color: 'white', border: '1px solid #44d62c'}}
            negativePress={() => props.close()}
            negativeTitle={'Cancel'}
            width={'40%'}
        >
            Are you sure you want to mark this order as unpaid?
        </AppDialog>
    )
}

export default UnpaidOrder;